import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import './SiteLoader.css';

const SiteLoader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // 2.5 seconds total

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className={`site-loader ${!isLoading ? 'site-loader--fade-out' : ''}`}>
      <div className="site-loader__content">
        <div className="site-loader__logo">
          <Logo width={150} height={150} />
        </div>
        <div className="site-loader__text">
          <h2>The MINT School</h2>
          <p>Building A Solid Foundation</p>
        </div>
        <div className="site-loader__spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
      </div>
    </div>
  );
};

export default SiteLoader;
